import { IUser } from 'app/shared/model/user.model';

export interface ISelfDescription {
  id?: number;
  description?: string | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<ISelfDescription> = {};
